import React from "react";
import { Phone, Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CONTACT } from "@/data/site";
import Reveal from "@/components/Reveal";

export default function CTA() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      data-testid="cta-section"
      className="relative py-20 md:py-28 px-5 md:px-8 overflow-hidden"
      style={{
        backgroundImage: "linear-gradient(135deg, rgba(11,61,145,0.9), rgba(11,61,145,0.75)), url('https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?crop=entropy&cs=srgb&fm=jpg&w=1800&q=80')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-5xl mx-auto text-center">
        <Reveal>
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 border border-white/25 backdrop-blur-md text-white text-xs font-semibold tracking-[0.2em] uppercase mb-6">
            Your Next Journey Awaits
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight tracking-tight drop-shadow">
            Ready for Your Next <span className="text-[#F9B233]">Adventure?</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-white/90 max-w-2xl mx-auto leading-relaxed">
            Let Malviya Travel plan your perfect journey while you enjoy unforgettable memories with your loved ones.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Button
              data-testid="cta-call-btn"
              asChild
              className="bg-[#F9B233] hover:bg-[#e6a11f] text-[#0B3D91] rounded-full h-12 px-8 font-semibold shadow-lg hover:scale-[1.03] transition-all"
            >
              <a href={`tel:${CONTACT.phone.replace(/\s/g,'')}`}>
                <Phone className="w-4 h-4" /> Call Now
              </a>
            </Button>
            <Button
              data-testid="cta-book-btn"
              onClick={() => scrollTo("#contact")}
              variant="outline"
              className="bg-white/10 backdrop-blur-md border-white/50 text-white hover:bg-white hover:text-[#0B3D91] rounded-full h-12 px-8 font-semibold transition-all"
            >
              <Compass className="w-4 h-4" /> Book Your Tour
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
